module.exports = __webpack_public_path__ + "img/Grappe_5.asset.c3612f09.svg";